import React, { useEffect } from "react";

export default function ImportCustomerModal({
  isOpen,
  onClose,
  onImport,
  customers = [],
  onFileSelect,
}) {
  //  ปิด scroll ของ body เวลา modal เปิด
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-xl shadow-lg w-[1000px] max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <img
              src="/assets/img/icon/fa-solid_user-alt.svg"
              alt="user"
              className="w-7 h-7"
            />
            <h2 className="text-[28px] font-bold text-[#E13F57] font-[Open_Sans] leading-normal">
              นำเข้าข้อมูลลูกค้า
            </h2>
          </div>

          {/* ปุ่มเลือกไฟล์ */}
          <label
            className="
              flex items-center justify-center gap-2
              w-[180px] h-[40px] px-[15px] py-[8px] shrink-0
              rounded-[10px] bg-[#F17F25] cursor-pointer
              text-white font-[Open_Sans] font-bold text-[14px] 
              hover:opacity-90 transition
            "
          >
            <img src="/assets/img/icon/gg_add.svg" alt="add" className="w-5 h-5" />
            เลือกไฟล์
            <input
              type="file"
              accept=".csv,.xlsx"
              className="hidden"
              onChange={onFileSelect}
            />
          </label>
        </div>

        {/* Table */}
        <div className="flex-1 overflow-auto p-4">
          <div className="overflow-x-auto border rounded-lg shadow-sm">
            <table className="w-full border-collapse text-sm">
              <thead>
                <tr className="bg-red-500 text-white text-center">
                  <th className="px-3 py-2">ลำดับ</th>
                  <th className="px-3 py-2">กลุ่มลูกค้า</th>
                  <th className="px-3 py-2">ประเภทลูกค้า</th>
                  <th className="px-3 py-2">รหัสลูกค้า</th>
                  <th className="px-3 py-2">ชื่อลูกค้า/บริษัท</th>
                  <th className="px-3 py-2">เบอร์โทรศัพท์</th>
                  <th className="px-3 py-2">สถานที่บริการ</th>
                </tr>
              </thead>
              <tbody>
                {customers.length > 0 ? (
                  customers.map((c, idx) => (
                    <tr
                      key={idx}
                      className={`text-center ${
                        idx % 2 === 0 ? "bg-white" : "bg-gray-50"
                      }`}
                    >
                      <td className="px-3 py-2">{idx + 1}</td>
                      <td className="px-3 py-2">
                        {c.AR_Type === "1" ? (
                          <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-700">
                            ลูกค้าทั่วไป
                          </span>
                        ) : (
                          <span className="px-2 py-1 text-xs rounded-full bg-purple-100 text-purple-700">
                            ลูกค้ามุ่งหวัง
                          </span>
                        )}
                      </td>
                      <td className="px-3 py-2">
                        {c.AR_Group === 1 ? "บุคคลธรรมดา" : "นิติบุคคล"}
                      </td>
                      <td className="px-3 py-2">{c.AR_Code || "-"}</td>
                      <td className="px-3 py-2">{c.AR_Name || "-"}</td>
                      <td className="px-3 py-2">{c.AR_Tel || "-"}</td>
                      <td className="px-3 py-2">
                        <img
                          src="/assets/img/icon/mingcute_location-fill.svg"
                          alt="location"
                          className="w-5 h-5 mx-auto"
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={7}
                      className="py-6 text-gray-400 text-center italic"
                    >
                      ยังไม่มีข้อมูลสำหรับนำเข้า
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {customers.length > 0 && (
            <p className="mt-3 text-sm text-gray-600">
              จำนวนที่นำเข้าได้ {customers.length} คน
            </p>
          )}
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-4 px-6 py-6 border-t bg-gray-50">
          <button
            onClick={onClose}
            className="
              w-[349px] h-[40px] shrink-0
              rounded-[10px] border border-[#E13F57]
              text-[#E13F57] font-[Open_Sans] font-bold text-[14px]
              hover:bg-red-50 transition
            "
          >
            ยกเลิก
          </button>

          <button
            onClick={onImport}
            disabled={customers.length === 0}
            className="
              w-[349px] h-[40px] shrink-0
              rounded-[10px] bg-[#E13F57]
              text-white font-[Open_Sans] font-bold text-[14px]
              hover:bg-[#c92d46] transition disabled:opacity-50
            "
          >
            นำเข้า
          </button>
        </div>
      </div>
    </div>
  );
}
